import { OTHER_PROPS } from 'common/constants/component-props';

const DEFAULT_VIDEO_SRC =
	'https://assets.dev.story-cards.com/abr_vods/storycards/a93ba043-4ee3-4653-b67a-75068482d1af/vod.m3u8';
const DEFAULT_VIDEO_POSTER =
	'https://assets.dev.story-cards.com/abr_vods/storycards/a93ba043-4ee3-4653-b67a-75068482d1af/vod_frames_poster.0000000.jpg';

export const defaultProps = {
	[OTHER_PROPS.video.videoSrc]: DEFAULT_VIDEO_SRC,
	[OTHER_PROPS.video.videoPoster]: DEFAULT_VIDEO_POSTER,
	[OTHER_PROPS.video.controls]: false,
	[OTHER_PROPS.video.autoplay]: false,
	[OTHER_PROPS.video.loop]: false,
	[OTHER_PROPS.video.muted]: false,
	[OTHER_PROPS.video.autopause]: true,
	[OTHER_PROPS.video.soundControl]: true,
	[OTHER_PROPS.video.playbackSpeedControl]: false,
	[OTHER_PROPS.video.fullscreenControl]: true,
	[OTHER_PROPS.video.pipModeControl]: true,
	[OTHER_PROPS.video.skipControl]: false,
};
